/**
 * created by xcc
 * 新媒体矩阵-微信榜单
 * */
import React, {Component} from 'react';
// import *as Action from "../../actions/horizontalManagement"
import MediaMatrixNewList from "./mediaMatrixNewList";
import {uuid} from "../../../../utils";
import NewMediaMatrixList from "../newMediaMatrixList/NewMediaMatrixList";

export default class MediaList extends Component {
    constructor(props) {
        super(props);
        // this.Actions = Action;
        this.state = {
            isShow: false,
            loadKey: uuid()
        }
    }

    componentDidMount() {
    }

    showFun = (isShow) => {
        this.setState({
            isShow,
            loadKey: uuid()
        })
    }

    render() {
        return (
            <div key={this.state.loadKey} style={{maxHeight: 'calc(100vh - 100px)'}}>
                <div style={{display: this.state.isShow ? "block" : "none"}}><NewMediaMatrixList showFun={()=>this.showFun(false)}/></div>
                <div style={{display: this.state.isShow ? "none" : "block"}}><MediaMatrixNewList showFun={()=>this.showFun(true)}/></div>
            </div>
        );
    }
}